import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import payment from "./modules/payment";

Vue.use(Vuex, VueAxios, axios);

const URL_V1 = process.env.VUE_APP_API_URL;

let abstractApi = axios.create({
  headers: {
    'locale': 'en',
    'x-api-key': localStorage.getItem('x-api-key')
  }
});

let authServerApi = axios.create({
  headers: {'x-api-key': localStorage.getItem('x-api-key')}
});

const rawAuthor = {
  "firstname": "",
  "lastname": "",
};

export default new Vuex.Store({
  modules: {payment},
  state: {
    poster: [],
    language: 'en',
    login: {'success': false},
    pages: [],
    processing: {
      'author': false,
      'institute': false,
      'dynamicdata': false,
      'rulex': false,
      'validation': false,
      'qr': false,
      'submit': false
    },
    settings: {},
    status: [],
    posters: {},
    submissions: [],
    user: {},
    usermapping: null,
    validation: {"is_checked": false, "status": false, "errors": {}},
    authorvalidation: {"is_checked": false, "status": false, "errors": []},
    wording: [],
    rulexvalue: 0,
    cache: {'abstract_id': null, 'submission_id': null},
    mode: {'confirm': false},
    prefilledToken: null
  },
  actions: {
    GET_POSTERS: function ({commit, state, dispatch}, submission_id) {
      abstractApi.get(URL_V1 + '/overview/' + submission_id, {
        headers: {
          "eposter-token": localStorage.getItem('eposter-token')
        }
      }).then((response) => {
        commit('SET_POSTERS', {posters: response.data, submission_id: submission_id})
      }, (err) => {
        // @todo handle this error
      })
    },
    GET_ONE_POSTER: function ({commit, state, dispatch}, id) {
      commit('SET_POSTER', {});
      abstractApi.get(URL_V1 + '/poster/' + id,).then((response) => {
        dispatch('IMPLODE_ADDITIONAL_ABSTRACT_DATA', response.data);
        let submission = state.submissions.find(submission => submission.id === response.data.setting_submission_id);
        commit('SET_SETTINGS', {settings: submission.settings});
      }, (err) => {
        // @todo handle this error
      })
    },
    GET_ALL_STATUS: function ({commit}) {
      abstractApi.get(URL_V1 + '/status').then((response) => {
        commit('SET_STATUS', {status: response.data})
      }, (err) => {
        // @todo handle this error
      })
    },
    GET_ALL_WORDING: function ({commit}, language) {
      abstractApi.get(URL_V1 + '/wording?language=' + language).then((response) => {
        commit('SET_WORDING', {wording: response.data})
      }, (err) => {
        // @todo handle this error
      })
    },
    GET_ALL_SUBMISSIONS: function ({commit}) {
      abstractApi.get(URL_V1 + '/settings/submission').then((response) => {
        commit('SET_SUBMISSIONS', {submissions: response.data})
      }, (err) => {
        // @todo handle this error
      })
    },
    GET_ALL_PAGES: function ({commit}) {
      abstractApi.get(URL_V1 + '/settings/page' + '?order=order&sort=asc').then((response) => {
        commit('SET_PAGES', {pages: response.data})
      }, (err) => {
        // @todo handle this error
      })
    },
    GET_USERDATA: function ({commit}) {
      return authServerApi.get(process.env.VUE_APP_AUTH_URL + 'api/user')
    },
    USER_CHECK_MAPPING: function ({commit}, user_id) {
      return abstractApi.post(URL_V1 + '/user/check/mapping', {'user_id': user_id})
    },
    USER_UPDATE_MAPPING: function ({commit}, data) {
      return abstractApi.post(URL_V1 + '/user/update/mapping', data)
    },
    PUT_POSTER: (state, id) => {
      let additionalKey = 'content';
      let additionalContent = {};
      let abstract = {};
      Object.assign(abstract, state.getters.poster);
      let cc = 0;
      for (let itemkey in abstract) {
        if (!itemkey.startsWith(additionalKey + '__')) {
          continue;
        }
        cc++;
        additionalContent[itemkey.replace(additionalKey + '__', '')] = abstract[itemkey]
        delete abstract[itemkey];
      }
      if (cc > 0) {
        abstract[additionalKey] = additionalContent;
      }
      return abstractApi.post(URL_V1 + '/poster/' + id, abstract)
    },
    RESET_POSTER: (state, id) => {
      return abstractApi.get(URL_V1 + '/poster/' + id + '/reset2edit')
    },
    SUBMIT_POSTER: (state, id) => {
      let additionalKey = 'content';
      let additionalContent = {};
      let abstract = {};
      Object.assign(abstract, state.getters.poster);
      abstract.status_id = 2;
      let cc = 0;
      for (let itemkey in abstract) {
        if (!itemkey.startsWith(additionalKey + '__')) {
          continue;
        }
        cc++;
        additionalContent[itemkey.replace(additionalKey + '__', '')] = abstract[itemkey]
        delete abstract[itemkey];
      }
      if (cc > 0) {
        abstract[additionalKey] = additionalContent;
      }
      return abstractApi.post(URL_V1 + '/poster/' + id + '/submit', abstract,)
    },
    IMPLODE_ADDITIONAL_ABSTRACT_DATA: function ({commit, state, dispatch}, data) {
      let additionalKey = 'content';
      if (!Object.keys(data).includes(additionalKey)) {
        commit('SET_POSTER', {poster: data})
      } else {
        let additionals = data[additionalKey];
        delete data[additionalKey];
        for (let itemkey in additionals) {
          data[additionalKey + '__' + itemkey] = additionals[itemkey];
        }
        commit('SET_POSTER', {poster: data})
      }
    },
    VALIDATE: function ({commit, state, dispatch}, data) {
      abstractApi.post(URL_V1 + '/validate', state.poster
      ).then((response) => {
        let validation = {"is_checked": true, "status": true, "errors": {}};
        commit('SET_VALIDATION', {validation: validation});
      }).catch((error) => {
        let validation = {"is_checked": true, "status": false, "errors": error.response.data};
        commit('SET_VALIDATION', {validation: validation});
      })
    },
    GET_QR: function ({commit, state}, id) {
      state.processing.qr = true;
      authServerApi.get(URL_V1 + '/poster/' + id + '/qrcode', {responseType: "blob"}).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "qrcode.png");
        document.body.appendChild(link);
        state.processing.qr = false;
        link.click();
      }).catch(() => {
        state.processing.qr = false;
        Vue.noty.error("QRCode could not be generated.");
      });
    },
    VALIDATE_TARGET: function ({commit, state, dispatch}, data) {
      return abstractApi.post(URL_V1 + '/validate/' + data.target, data.template);
    },
    CHECK_LOGIN: function ({commit}, token) {
      return abstractApi.post(URL_V1 + '/user/login_token', {'token': token})
    },
    logout: (state, data) => {
      localStorage.removeItem('x-api-key');
      localStorage.removeItem('eposter-token');
    },
  },
  mutations: {
    SET_POSTERS: (state, {posters, submission_id}) => {
      Vue.set(state.posters, submission_id, posters)
      // state.submission_abstracts[submission_id] = abstracts;
    },
    SET_POSTER: (state, {poster}) => {
      state.poster = poster
    },
    SET_STATUS: (state, {status}) => {
      state.status = status
    },
    SET_WORDING: (state, {wording}) => {
      state.wording = wording
    },
    SET_SUBMISSIONS: (state, {submissions}) => {
      state.submissions = submissions
    },
    SET_SETTINGS: (state, {settings}) => {
      state.settings = JSON.parse(settings)
    },
    SET_PAGES: (state, {pages}) => {
      state.pages = pages
    },
    SET_VALIDATION: (state, {validation}) => {
      state.validation = validation
    },
    SET_RULEXVALUE: (state, {rulex}) => {
      state.rulexvalue = rulex
    },
    SET_USER: (state, {user}) => {
      state.user = user
    },
    SET_PREFILLED_TOKEN: (state, {prefilledToken}) => {
      state.prefilledToken = prefilledToken
    },
    SET_TOKEN: (state, {token}) => {
      abstractApi.defaults.headers['x-api-key'] = token;
      authServerApi.defaults.headers['x-api-key'] = token;
    }
  },
  getters: {
    poster: (state) => {
      return state.poster
    },
    wording: (state) => {
      return state.wording
    },
    getCurrentPages: (state) => (submission_id) => {
      return state.pages.filter(page => page.setting_submission_id === submission_id)
    },
    getFirstCurrentPage: (state) => (submission_id) => {
      return state.pages.find(page => page.setting_submission_id === submission_id && page.order === 1)
    },
    getCurrentPageById: (state) => (page_id) => {
      return state.pages.find(page => page.id === page_id)
    },
    getCurrentPageByType: (state) => (submission_id, page_type) => {
      return state.pages.find(page => page.setting_submission_id === submission_id && page.setting_page_type_id === page_type)
    },
    getSettings: (state) => (submission_id) => {
      return JSON.parse(state.submissions.find(submission => submission.id === submission_id).settings)
    },
    isOpen: (state) => (submission_id) => {
      return state.submissions.find(submission => submission.id === submission_id).isOpen
    }
  },
})
